import React, { useEffect, useState } from "react";
import AdminLeave from "./component/AdminLeave";

const AdminLeaveView = () => {

  const [currentPage, setCurrentPage] = useState(null);
  const [pageSize, setPageSize] = useState(null);
  const [totalRecord, settotalRecord] = useState(null);
  const [totalPage, settotalPage] = useState(null);

  return (
    <>
      {
        <AdminLeave
          currentPage={currentPage}
          pageSize={pageSize}
          totalRecord={totalRecord}
          totalPage={totalPage}
          setCurrentPage={setCurrentPage}
          setPageSize={setPageSize}
        />
      }
    </>
  );
};

export default AdminLeaveView;
